export enum CommonCatalogsNamesEnum {
  CHECKLIST_ANSWER_TYPES = 'CHECKLIST_ANSWER_TYPES',
  ERKNM_KNM_EXPERT_TYPES = 'ERKNM_KNM_EXPERT_TYPES',
  KNM_ADDRESS_TYPES = 'KNM_ADDRESS_TYPES',
  KNM_DELEGATE_TYPES = 'KNM_DELEGATE_TYPES',
  KNM_DOCUMENT_TYPES = 'KNM_DOCUMENT_TYPES',
  ERKNM_KNM_DOCUMENT_TYPES = 'ERKNM_KNM_DOCUMENT_TYPES',
  DECISION_DOCUMENT_TYPES = 'DECISION_DOCUMENT_TYPES',
  KNM_EXECUTION_TYPES = 'KNM_EXECUTION_TYPES',
  KNM_EXECUTION_TYPES_ALL = 'KNM_EXECUTION_TYPES_ALL',
  KNM_INSPECTOR_TYPES = 'KNM_INSPECTOR_TYPES',
  KNM_INSPECTORS = 'KNM_INSPECTORS',
  KNM_LINK_TYPES = 'KNM_LINK_TYPES',
  KNM_NOTICE_METHODS = 'KNM_NOTICE_METHODS',
  KNM_NOTICE_METHODS_ALL = 'KNM_NOTICE_METHODS_ALL',
  KNM_OBJECT_TYPES = 'KNM_OBJECT_TYPES',
  LIST_TYPES = 'LIST_TYPES',
  KNO_ADMIN_LEVELS = 'KNO_ADMIN_LEVELS',
  KNM_RESULT_INFO_TYPES = 'KNM_RESULT_INFO_TYPES',
  KNM_SUBJECT_TYPES = 'KNM_SUBJECT_TYPES',
  KNM_TYPES_CANCELED = 'KNM_TYPES_CANCELED',
  KNM_TYPES_294 = 'KNM_TYPES_294',
  KNM_STATUSES_248 = 'KNM_STATUSES_248',
  KNM_STATUSES_294 = 'KNM_STATUSES_294',
  PM_STATUSES = 'PM_STATUSES',
  DECISION_STATUSES = 'DECISION_STATUSES',
  KNM_SUBJECT_TYPES_ALL = 'KNM_SUBJECT_TYPES_ALL',
  KNM_TYPES_ALL = 'KNM_TYPES_ALL',
  KNM_KINDS_ALL = 'KNM_KINDS_ALL',
  KNM_VIOLATION_TYPES = 'KNM_VIOLATION_TYPES',
  KNM_VIOLATION_TYPES_ALL = 'KNM_VIOLATION_TYPES_ALL',
  KNM_YEARS = 'KNM_YEARS',
  RISK_CATEGORIES = 'RISK_CATEGORIES',
  TEST_PURCHASE_METHODS = 'TEST_PURCHASE_METHODS',
  VIOLATION_LAWSUIT_TYPES = 'VIOLATION_LAWSUIT_TYPES',
  KNM_PLAN_TYPES = 'KNM_PLAN_TYPES',
  USER_KNOS = 'USER_KNOS',
  USER_PROSECUTORS = 'USER_PROSECUTORS',
  FEDERAL_LAWS_248 = 'FEDERAL_LAWS_248',
  FEDERAL_LAWS_294 = 'FEDERAL_LAWS_294',
  SUPERVISION_TYPES = 'SUPERVISION_TYPES',
  CHECKLIST_FULLNESS_TYPES = 'CHECKLIST_FULLNESS_TYPES',
  REGISTER_TYPES = 'REGISTER_TYPES',
  KNM_PLAN_REASON_CHANGE_TYPES = 'KNM_PLAN_REASON_CHANGE_TYPES',
  KNM_EXCLUSION_REASONS = 'KNM_EXCLUSION_REASONS',
  KNM_RESPONSIBLE_TYPES = 'KNM_RESPONSIBLE_TYPES',
  ERKNM_ACQUAINTANCE_TYPES = 'ERKNM_ACQUAINTANCE_TYPES',
  ERKNM_ACQUAINTANCE_LACK_TYPES = 'ERKNM_ACQUAINTANCE_LACK_TYPES',
  ERKNM_SUBMITTED_DOCUMENTS_STATUS = 'ERKNM_SUBMITTED_DOCUMENTS_STATUS',
  RESPONSIBILITY_TYPES = 'RESPONSIBILITY_TYPES',
  ERKNM_KIND_RESULT_DECISION = 'ERKNM_KIND_RESULT_DECISION',
  MSP_CATEGORIES = 'MSP_CATEGORIES',
  TERRITORIAL_UNITS = 'TERRITORIAL_UNITS',
  TERRITORIAL_UNITS_BY_LEVELS_COUNTRY_FEDERAL_DISTRICTS_REGIONS = 'TERRITORIAL_UNITS_BY_LEVELS_COUNTRY_FEDERAL_DISTRICTS_REGIONS',
  PROSECUTOR_ORGANIZATIONS = 'PROSECUTOR_ORGANIZATIONS',
  ANALYTICS_TERRITORIAL_UNITS = 'ANALYTICS_TERRITORIAL_UNITS',
  ROLES = 'ROLES',
  KNM_ACT_TYPES = 'KNM_ACT_TYPES',
  PM_PROF_ACT_TYPES = 'PM_PROF_ACT_TYPES',
  KNM_CANCELED_REASONS = 'KNM_CANCELED_REASONS',
  COUNTRIES = 'COUNTRIES',
  GENERIC_REASONS = 'GENERIC_REASONS',
  DECISION_GENERIC_REASONS = 'DECISION_GENERIC_REASONS',
  MANDATORY_CATEGORIES = 'MANDATORY_CATEGORIES',
  INTERACTION_CATEGORIES = 'INTERACTION_CATEGORIES',
  PM_FORMS_CONDUCTING = 'PM_FORMS_CONDUCTING ',
  JUDGMENT_COURTS = 'JUDGMENT_COURTS',
  JUDGMENT_COURT_LEVELS = 'JUDGMENT_COURT_LEVELS',
  JUDGMENT_KINDS = 'JUDGMENT_KINDS',
  JUDGMENT_PROSECUTION_TYPES = 'JUDGMENT_PROSECUTION_TYPES',
  JUDGMENT_PUNISHMENT_TYPES = 'JUDGMENT_PUNISHMENT_TYPES',
  JUDGMENT_PUNISHMENT_INDEX = 'JUDGMENT_PUNISHMENT_INDEX',
  JUDGMENT_CANCELLATION_INFORMATION = 'JUDGMENT_CANCELLATION_INFORMATION',
  DISTRICTS = 'DISTRICTS',
  KNM_ACCESS_LEVELS = 'KNM_ACCESS_LEVELS',
  PM_CANCELED_REASONS = 'PM_CANCELED_REASONS',
  KNM_REASONS_CANCELED = 'KNM_REASONS_CANCELED',
  VIOLATION_MATERIAL_TYPE = 'VIOLATION_MATERIAL_TYPE',
  VIOLATION_FIX_METHOD = 'VIOLATION_FIX_METHOD',
  VIOLATION_FIX_GRADE = 'VIOLATION_FIX_GRADE',
  KNO_LEVELS = 'KNO_LEVELS',
  KNM_REMARKS = 'KNM_REMARKS',
  KNM_REMARKS_ALL = 'KNM_REMARKS_ALL',
  PASSPORT_MASS_CANCEL_REASON = 'PASSPORT_MASS_CANCEL_REASON',
  PASSPORT_MASS_DELETE_REASON = 'PASSPORT_MASS_DELETE_REASON',
  ERVK_ORDERS = 'ERVK_ORDERS',
  AGREEMENT_CHANGE_REASON = 'AGREEMENT_CHANGE_REASON',
  TERMINATION_REASONS = 'TERMINATION_REASONS',
  UAV_TYPES = 'UAV_TYPES',
}
